import { useCallback, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./TriviaCoco.module.css";
import ProgressBar from "../components/ProgressBar";
import Trivia from "../components/Trivia";
import NavPanel from "../components/NavPanel";
import NBLogoWhite from "../components/NBLogoWhite";


const TriviaChase = () => {
  const navigate = useNavigate();

  const [correctedAnswer, setCorrectedAnswer] = useState(false);
 
  const videoRef = useRef(null);

  const checkoutCloset = useCallback(() => {
    navigate("/tommy-closet");
  }, [navigate]);


  const previousPage = useCallback(() => {
    navigate("/who-best");
  }, [navigate]);

  const onCorrect = (value) => {
    setCorrectedAnswer(value)
    if(videoRef.current) {
      if (value) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    }
  }

  const choices = [
    { number: 'A', answer: 'Left', correct: false },
    { number: 'B', answer: 'Right', correct: true },
    { number: 'C', answer: 'Switches', correct: false },
    { number: 'D', answer: 'Ambidextrous', correct: false }
  ]
  const question = 'What is Tommy Paul’s dominant hand?'
  const message = "Tommy Paul plays right-handed and uses a two-handed backhand in matches."
  const correct = 'D'
  const title = "Not Quite."

  return (
    <div className={styles.cocoTrivia}>
      <NavPanel onClick={previousPage} />
      <NavPanel postion='right' onClick={checkoutCloset} />
      <ProgressBar current='2' />
      <NBLogoWhite/>
      <div className={styles.gradient}></div>

      <div className={styles.player}>
        <video 
          src="applause.mp4" 
          ref={videoRef}
          playsInline
          loop
          style={{
            height: '100%',
            width: '100%',
            objectFit: 'cover'
          }}
          className={correctedAnswer ? '' : 'hide'}
        />
        
        { !correctedAnswer && <img className={styles.cocoImage} src='tommy_trivia.png'></img> }
      </div>

      <div className={styles.frameParent}>
        <Trivia
          question={question}
          choices={choices}
          question_id={6}
          info={message}
          onCorrect={onCorrect}
          wrongTitle={title}
        />
      </div>
      <div className={styles.checkoutButton} >
        <div className= {styles.question} onClick={checkoutCloset} >
        Check out Tommy Paul’s Closet ➔
        </div>
      </div>
    </div>
  )
}
export default TriviaChase;
